import React from "react";

export default function Base({}) {
	return <>
		<path d="M42.567 0L0 50L42.567 100L85.134 50L42.567 0Z"/>
	</>
}